export default function TestimonialSection() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-12 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 md:gap-0">
          {/* Left - testimonial */}
          <div className="lg:w-3/5">
            <p className="text-xs font-semibold text-accent-600 uppercase tracking-wider mb-6">
              &bull; Verified Reviews
            </p>
            <blockquote className="font-heading text-2xl md:text-4xl text-foreground-950 leading-snug mb-6">
              &ldquo;ACBuySpreadsheet is the only tool I use for product tracking now. It has completely changed how I organize my buying decisions.&rdquo;
            </blockquote>
            <div className="flex items-center gap-3">
              <span className="text-sm font-semibold text-foreground-900">Sarah Mitchell</span>
              <span className="flex items-center gap-1 text-xs text-accent-500 font-medium">
                <i className="ri-verified-badge-fill text-base"></i> Verified Buyer
              </span>
            </div>
          </div>

          {/* Right - portrait */}
          <div className="lg:w-2/5 flex justify-center lg:justify-end">
            <div className="w-64 h-80 md:w-80 md:h-96 rounded-2xl overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20confident%20smiling%20woman%20with%20shoulder%20length%20wavy%20auburn%20hair%20wearing%20a%20cream%20cashmere%20sweater%2C%20photographed%20against%20a%20light%20warm%20gray%20textured%20paper%20backdrop%20with%20soft%20Rembrandt%20lighting%20from%20upper%20left%20creating%20a%20gentle%20triangle%20of%20light%20on%20her%20cheek%2C%20editorial%20lifestyle%20portrait%20photography%20with%20warm%20approachable%20genuine%20expression%20and%20shallow%20depth%20of%20field&width=700&height=900&seq=testimonial-portrait-v2&orientation=portrait"
                alt="Verified ACBuySpreadsheet reviewer"
                title="ACBuySpreadsheet Customer Review"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}